module.exports = __webpack_public_path__ + "img/4c97cbcc987cbacd6038d6e94fa18d8c.png";